module.exports = __webpack_public_path__ + "img/tab_bg.a5987160.svg";